export default function WellnessLifestyle() {
  const lifestyleImages = [
    {
      image: 'https://public.readdy.ai/ai/img_res/ba6c1b18050003cc203846df60e65b8a.jpg',
      title: 'Radiant Beauty',
      description: 'Premium skincare and beauty supplements',
      link: '/radiant-beauty'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Handsome%20athletic%20man%20with%20short%20dark%20hair%20applying%20facial%20moisturizer%20in%20modern%20bathroom%20mirror%20with%20natural%20morning%20light%2C%20professional%20lifestyle%20photography%2C%20mens%20grooming%20routine%20aesthetic%20with%20clean%20minimalist%20background%20and%20wellness%20products%20visible&width=600&height=800&seq=menslifestyle001&orientation=portrait',
      title: 'Daily Grooming',
      description: 'Essential skincare for modern men',
      link: '/daily-grooming'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Fit%20woman%20in%20athletic%20wear%20drinking%20collagen%20smoothie%20after%20yoga%20workout%20in%20bright%20modern%20kitchen%2C%20holding%20elegant%20supplement%20bottle%20with%20peaceful%20smile%2C%20healthy%20lifestyle%20and%20beauty%20from%20within%20aesthetic%20with%20natural%20lighting%20and%20wellness%20theme&width=600&height=800&seq=womenwellness002&orientation=portrait',
      title: 'Beauty From Within',
      description: 'Collagen and beauty supplements',
      link: '/beauty-supplement'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Confident%20fit%20man%20with%20dark%20hair%20taking%20protein%20supplements%20and%20vitamins%20in%20bright%20modern%20kitchen%20setting%2C%20professional%20lifestyle%20photography%2C%20healthy%20mens%20wellness%20routine%20aesthetic%20with%20natural%20lighting%20and%20athletic%20lifestyle%20theme&width=600&height=800&seq=menslifestyle002&orientation=portrait',
      title: 'Peak Performance',
      description: 'Essential supplements for active lifestyle',
      link: '/sports-nutrition'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Serene%20woman%20meditating%20peacefully%20in%20bright%20living%20room%20with%20supplement%20bottles%20nearby%2C%20practicing%20mindfulness%20and%20stress%20relief%20routine%2C%20calm%20wellness%20lifestyle%20aesthetic%20with%20soft%20natural%20lighting%20and%20tranquil%20atmosphere&width=600&height=800&seq=womenwellness003&orientation=portrait',
      title: 'Stress Relief',
      description: 'Mood support and relaxation supplements',
      link: '/brain-support'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Athletic%20man%20with%20short%20dark%20hair%20using%20massage%20gun%20on%20shoulder%20muscles%20after%20workout%20in%20modern%20gym%20setting%2C%20professional%20lifestyle%20photography%2C%20mens%20recovery%20and%20wellness%20aesthetic%20with%20clean%20background%20and%20fitness%20equipment%20visible&width=600&height=800&seq=menslifestyle003&orientation=portrait',
      title: 'Recovery & Wellness',
      description: 'Professional tools for muscle recovery',
      link: '/post-workout'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Happy%20pregnant%20woman%20taking%20prenatal%20vitamins%20in%20cozy%20nursery%20room%20with%20soft%20pastel%20colors%2C%20holding%20supplement%20bottle%20with%20gentle%20maternal%20smile%2C%20nurturing%20pregnancy%20wellness%20routine%20aesthetic%20with%20warm%20lighting%20and%20peaceful%20atmosphere&width=600&height=800&seq=womenwellness004&orientation=portrait',
      title: 'Prenatal Care',
      description: 'Complete nutrition for expecting mothers',
      link: '/vitamins'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Handsome%20man%20with%20dark%20hair%20applying%20beard%20oil%20and%20grooming%20beard%20in%20modern%20bathroom%20with%20natural%20lighting%2C%20professional%20lifestyle%20photography%2C%20luxury%20mens%20grooming%20routine%20aesthetic%20with%20elegant%20minimalist%20background%20and%20premium%20products%20visible&width=600&height=800&seq=menslifestyle004&orientation=portrait',
      title: 'Beard Care',
      description: 'Premium grooming essentials',
      link: '/personal-care'
    },
  ];

  const handleClick = (link: string) => {
    window.REACT_APP_NAVIGATE(link);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Complete Wellness Collection
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Elevate your wellness routine with premium supplements and products designed for everyone
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {lifestyleImages.map((item, index) => (
            <div 
              key={index}
              onClick={() => handleClick(item.link)}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-96 overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-sm text-white/90">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
